import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { PHBHPFeaturePackageEvaluationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/public_api';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { TranslationKeys } from 'ph-bhp-localization';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'lib-ph-bhp-consumption-statical-evaluation',
  templateUrl: './ph-bhp-consumption-statical-evaluation.component.html',
  styleUrls: ['./ph-bhp-consumption-statical-evaluation.component.css']
})
export class PhBhpConsumptionStaticalEvaluationComponent implements OnInit {

  @Output() childData = new EventEmitter();
  translationKeys: typeof TranslationKeys = TranslationKeys;
  subscription: Subscription;
  subscriptionUser: Subscription;
  roleId: number;

  constructor(private router: Router, private evaluationService: PHBHPFeaturePackageEvaluationService, public appConfig: AppConfig, public layoutService: PHBHPLayoutPackageService) { }

  async ngOnInit() {
    if (this.appConfig.userData) {
      this.roleId = this.appConfig.userData.roleName.roleId;
    } else {
      this.subscriptionUser = this.appConfig.userSubject.asObservable().subscribe(res => {
        this.roleId = this.appConfig.userData.roleName.roleId;
      })
    }
  }

  emitData(event) {
    switch (event.key) {
      case 'totalConsumption': this.router.navigate(['evaluation/consumption/totalConsumption']); break;
      case 'consumptionPerPatient': this.router.navigate(['evaluation/consumption/consumptionPerPatient']); break;
      default: this.router.navigate(['evaluation/consumption/statistical']); break;

    }
  }
}
